import { APP_INFO } from '../actions/action-types'

const initialState = {
  language: null,
  appInfo: { initialized: false },
}

// eslint-disable-next-line default-param-last
const commons = (state = initialState, action) => {
  switch (action.type) {
    case APP_INFO:
      return {
        ...state,
        appInfo: {
          initialized: true,
          newVersion:
            state.appInfo.newVersion ||
            (state.appInfo._timestamp &&
              state.appInfo._timestamp < action.value._timestamp),
          ...action.value,
        },
      }
    default:
      return state
  }
}

export default commons
